import { network } from "apis";
import { Lead, LeadJSON } from "models/Lead";

export class LeadAPI {
  static upsertLead = async (leadJson: LeadJSON, rethrowError = true): Promise<void> => {
    const fullPath = `${Lead.path}`;
    const response = await network.callPost(fullPath, leadJson, rethrowError);
    if (!response || Math.floor((response?.status || 0) / 100) !== 2) { // 2XX
      throw Error("Upserting lead failed with code " + (response?.status || "undefined"));
    }
  }

  static getLead = async (leadKey: string): Promise<Lead|undefined> => {
    const fullPath = `${Lead.path}/${leadKey}`;
    const response = await fetch(fullPath)
    if(response.status === 404) {
      console.log("lead not found")
      return undefined
    }
    if (!response || Math.floor((response?.status || 0) / 100) !== 2) { // 2XX
      throw Error("Getting lead failed with code " + (response?.status || "undefined"));
    }

    return Lead.fromJSON(await response.json())
  }

  static upsertLeadData = async (leadKey: string, leadData:{[key:string]:any}, rethrowError = true): Promise<void> => {
    const fullPath = `${Lead.path}/${leadKey}/data`;
    const response = await network.callPost(fullPath, leadData, rethrowError);
    if (!response || Math.floor((response?.status || 0) / 100) !== 2) { // 2XX
      throw Error("Upserting lead data failed with code " + (response?.status || "undefined"));
    }
  }

  static getLeadData = async (leadKey: string): Promise<{[key:string]: any}> => {
    const fullPath = `${Lead.path}/${leadKey}/data`;
    // const response = await fetch(fullPath)
    const response = await fetch(fullPath)
    if(response.status === 404) {
      console.log("no lead data was found")
      return {}
    }
    if (Math.floor((response.status || 0) / 100) !== 2) { // 2XX
      throw Error("Getting lead data failed with code " + response.status);
    }

    return await response.json()
  }

  static linkToCurrentUserId = async (leadKey: string, rethrowError = true): Promise<void> => {
    const fullPath = `${Lead.path}/${leadKey}/link-user`;
    const response = await network.callPost(fullPath, {}, rethrowError);
    if (!response || Math.floor((response?.status || 0) / 100) !== 2) { // 2XX
      throw Error("Linking lead to user record failed with code " + (response?.status || "undefined"));
    }
  }

}
